import React, { useEffect, useRef } from "react";

// SASS
import "./Part13.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import computer1Img from "../../assets/img/desk.png";
import computer2Img from "../../assets/img/Desk-Notebook-Highlight.png";
import computer3Img from "../../assets/img/Desk-Watch-Highlight.png";

// FUNCTION EXPORT
export default function Part13({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    {
      stepNumber: "1",
      height: null,
      description: "fade in computer2, fade in bottom text 1",
    },
    {
      stepNumber: "2",
      height: null,
      description: "fade in computer3, fade in bottom text 2",
    },
    { stepNumber: "3", height: null, description: "spacer" },
  ];

  // REFS
  const computer2El = useRef(null);
  const computer3El = useRef(null);
  const bottomText1El = useRef(null);
  const bottomText2El = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnEnter(computer3El.current, direction);
            animate.fadeInOnEnter(bottomText1El.current, direction);
            break;
          }
          case "2": {
            animate.fadeOutOnEnter(bottomText1El.current, direction);
            animate.fadeInOnEnter(computer2El.current, direction);
            animate.fadeInOnEnter(bottomText2El.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnExit(computer3El.current, direction);
            animate.fadeOutOnExit(bottomText1El.current, direction);
            break;
          }
          case "2": {
            animate.fadeInOnExit(bottomText1El.current, direction);
            animate.fadeOutOnExit(computer2El.current, direction);
            animate.fadeOutOnExit(bottomText2El.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part13">
          <div className="computer computer-1">
            <img src={computer1Img} alt="" className="img-fluid" />
          </div>
          <div className="computer computer-3" ref={computer3El}>
            <img src={computer3Img} alt="" className="img-fluid" />
          </div>
          <div className="computer computer-2" ref={computer2El}>
            <img src={computer2Img} alt="" className="img-fluid" />
          </div>

          <div className="top-text">
            If you are <br />a supervisor,
          </div>
          <div className="bottom-text-container">
            <div className="bottom-text bottom-text-1" ref={bottomText1El}>
              Your room and equipment turnover plans should account for the
              contact time of disinfectants your colleagues use.
            </div>
            <div className="bottom-text bottom-text-2" ref={bottomText2El}>
              If turnover time is a concern, consider selecting another
              disinfectant that works best for the needed timelines, rather than
              use it incorrectly.
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
